let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7pA40")).then(() => parcelRequire('9ImcE'));